module.exports = __webpack_public_path__ + "img/icon-telegram.70a5c316.svg";